import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import FaviconFlagStyles from "./FaviconFlag.styled";
import { Helmet } from "react-helmet";
import { useAppStore } from "../../stores/AppStore";

function FaviconFlag({ location }) {
  const canvas = useRef();
  const ctx = useRef();
  const size = 180;
  const [{ colour1, colour2 }] = useAppStore();
  const [favicon, setFavicon] = useState();

  const setup = () => {
    ctx.current = canvas.current.getContext("2d");
  };

  const clear = () => {
    ctx.current.save();
    ctx.current.setTransform(1, 0, 0, 1, 0, 0);
    ctx.current.clearRect(0, 0, size, size);
    ctx.current.restore();
  };

  const draw = async () => {
    const isHome =
      location.pathname === "/" ||
      location.pathname.substring(0, 13) === "/exhibitions/";
    if (isHome) {
      await drawAll();
      convertCanvasToImage();
      return;
    }
    if (location.pathname === "/about") {
      await drawLeft();
      convertCanvasToImage();
      return;
    }
    await drawRight();
    convertCanvasToImage();
  };

  const drawAll = async () => {
    ctx.current.fillStyle = colour1;
    ctx.current.fillRect(0, 0, size / 3, size);

    ctx.current.fillStyle = "#ffffff";
    ctx.current.fillRect(1 * (size / 3), 0, size / 3, size);

    ctx.current.fillStyle = colour2;
    ctx.current.fillRect(2 * (size / 3), 0, size / 3, size);
    return true;
  };

  const drawLeft = async () => {
    ctx.current.fillStyle = colour1;
    ctx.current.fillRect(0, 0, 2 * (size / 3), size);
    return true;
  };

  const drawRight = async () => {
    ctx.current.fillStyle = colour2;
    ctx.current.fillRect(size / 3, 0, 2 * (size / 3), size);
    return true;
  };

  const convertCanvasToImage = async () => {
    const favicon = await createImage();
    setFavicon(favicon);
  };

  const createImage = async () => {
    return canvas.current.toDataURL("image/png");
  };

  useEffect(() => {
    if (canvas.current && colour1 !== "") {
      setup();
      clear();
      draw();
    }
  }, [colour1, location]);

  return (
    <>
      <FaviconFlagStyles width={size} height={size} ref={canvas} />
      {favicon ? (
        <Helmet>
          <link rel="apple-touch-icon" sizes="180x180" href={favicon} />
          <link rel="icon" type="image/png" sizes="32x32" href={favicon} />
          <link rel="icon" type="image/png" sizes="16x16" href={favicon} />
        </Helmet>
      ) : null}
    </>
  );
}

export default FaviconFlag;
